export const CommonModelFamiliesValues = ['q3', 'q5', 'q7', 'a3', 'a5'];
